setToolTipProcessing